export enum EGamificationRewardActionType {
  ADD = 'ADD',
  SUBTRACT = 'SUBTRACT'
}

export enum EGamificationRewardType {
  REFERRAL = 'REFERRAL',
  ACTIVITY_SHARED = 'ACTIVITY_SHARED',
  ATTEND_TO_EVENT = 'ATTEND_TO_EVENT',
  TICKET_RESPONSE_LIKED = 'TICKET_RESPONSE_LIKED',
  HELPFUL_AI_TICKET_RESPONSE = 'HELPFUL_AI_TICKET_RESPONSE',
  COMPLETE_SECTION = 'COMPLETE_SECTION',
  QUIZ_COMPLETED = 'QUIZ_COMPLETED',
  FIRST_STEP_PROFILE_COMPLETED = 'FIRST_STEP_PROFILE_COMPLETED',
  FIRST_STEP_LIVE_CLASS_ADDED = 'FIRST_STEP_LIVE_CLASS_ADDED',
  FIRST_STEP_TASK_COMPLETED = 'FIRST_STEP_TASK_COMPLETED',
  FIRST_STEP_QUIZ_COMPLETED = 'FIRST_STEP_QUIZ_COMPLETED',
  FIRST_STEP_INTRODUCTION_COMPLETED = 'FIRST_STEP_INTRODUCTION_COMPLETED',
  FIRST_STEP_ACTIVITY_COMPLETED = 'FIRST_STEP_ACTIVITY_COMPLETED',
  LEGACY_COMPLETE_FREE_QUIZ_DAILY_ACTIONS = 'LEGACY_COMPLETE_FREE_QUIZ_DAILY_ACTIONS',
  LEGACY_COMPLETE_TWO_QUIZZES_DAILY_ACTIONS = 'LEGACY_COMPLETE_TWO_QUIZZES_DAILY_ACTIONS',
  LEGACY_COMPLETE_SECTION_DAILY_ACTIONS = 'LEGACY_COMPLETE_SECTION_DAILY_ACTIONS',
  LEGACY_COMPLETE_REVIEW_QUIZ_DAILY_ACTIONS = 'LEGACY_COMPLETE_REVIEW_QUIZ_DAILY_ACTIONS',
  LEGACY_SHARE_ACTIVITY_DAILY_ACTIONS = 'LEGACY_SHARE_ACTIVITY_DAILY_ACTIONS',
  LEGACY_GET_20_POINTS_DAILY_ACTIONS = 'LEGACY_GET_20_POINTS_DAILY_ACTIONS'
}
interface GamificationReward {
  points: number;
}

export const GAMIFICATION_REWARDS: Record<EGamificationRewardType, GamificationReward> = {
  [EGamificationRewardType.REFERRAL]: {
    points: 1500
  },
  [EGamificationRewardType.ACTIVITY_SHARED]: {
    points: 10
  },
  [EGamificationRewardType.TICKET_RESPONSE_LIKED]: {
    points: 1
  },
  [EGamificationRewardType.HELPFUL_AI_TICKET_RESPONSE]: {
    points: 10
  },
  [EGamificationRewardType.ATTEND_TO_EVENT]: {
    points: 15
  },
  [EGamificationRewardType.COMPLETE_SECTION]: {
    points: 5
  },
  [EGamificationRewardType.QUIZ_COMPLETED]: {
    points: 5
  },
  [EGamificationRewardType.FIRST_STEP_PROFILE_COMPLETED]: { points: 21 },
  [EGamificationRewardType.FIRST_STEP_LIVE_CLASS_ADDED]: { points: 21 },
  [EGamificationRewardType.FIRST_STEP_TASK_COMPLETED]: { points: 21 },
  [EGamificationRewardType.FIRST_STEP_QUIZ_COMPLETED]: { points: 21 },
  [EGamificationRewardType.FIRST_STEP_INTRODUCTION_COMPLETED]: { points: 21 },
  [EGamificationRewardType.FIRST_STEP_ACTIVITY_COMPLETED]: { points: 21 },
  [EGamificationRewardType.LEGACY_COMPLETE_FREE_QUIZ_DAILY_ACTIONS]: { points: 5 },
  [EGamificationRewardType.LEGACY_COMPLETE_TWO_QUIZZES_DAILY_ACTIONS]: { points: 5 },
  [EGamificationRewardType.LEGACY_COMPLETE_SECTION_DAILY_ACTIONS]: { points: 5 },
  [EGamificationRewardType.LEGACY_COMPLETE_REVIEW_QUIZ_DAILY_ACTIONS]: { points: 5 },
  [EGamificationRewardType.LEGACY_SHARE_ACTIVITY_DAILY_ACTIONS]: { points: 5 },
  [EGamificationRewardType.LEGACY_GET_20_POINTS_DAILY_ACTIONS]: { points: 8 }
};

export enum EBadgeTypes {
  GOLD = 'GOLD',
  SILVER = 'SILVER',
  BRONZE = 'BRONZE'
}
